import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'

const buttonClasses =
  'inline-flex items-center justify-center rounded-full bg-[#006045] px-5 py-3 text-sm font-semibold text-white shadow-xs transition hover:bg-[#004d37] focus:ring-2 focus:ring-[#006045]/20 focus:outline-none'

const HealthRecordsManagementCard: React.FC = () => (
  <section className="flex flex-col rounded-xl border border-[#E5E7EB] bg-white p-6 shadow-lg shadow-gray-900/10">
    <h2 className="text-2xl leading-9 font-semibold tracking-tight text-[#002C22]">
      <FormattedMessage id="home.healthRecordsManagement.title" defaultMessage="Manage health records" />
    </h2>
    <p className="text-text-body mt-3 text-sm leading-6">
      <FormattedMessage
        id="home.healthRecordsManagement.body"
        defaultMessage="View connected health systems, reconnect when needed, or share records from another health system."
      />
    </p>
    <div className="mt-6 flex justify-end">
      <Link to="/health-records/connect" className={buttonClasses}>
        <FormattedMessage id="home.healthRecordsManagement.button" defaultMessage="Manage connections" />
      </Link>
    </div>
  </section>
)

export default HealthRecordsManagementCard
